import { PAPERWORK } from '../../constants/routes';

export const checkIsPaperworkRoute = () => {
  const { pathname } = window.location;

  return { isPaperworkRoute: pathname.includes(PAPERWORK), route: pathname };
};



// WEBPACK FOOTER //
// ./src/utils/paperwork/checkIsPaperworkRoute.js